import FootballState from "../../../../sports/football/state/football-state";
import { isDefined } from "../../../common/object-util";

export const DriveSerializer = {
    serialize(drive, gameContext) {
        const {
            startTime,
            endTime,
            startPeriod,
            endPeriod,
            homeTeamHasPossession,
            startType,
            endType,
            totalTime,
            plays = [],
            startYard,
            endYard
        } = drive;

        // TODO: Do we have to sort plays here? Should be sorted already; const sortedPlays = plays.sort((a, b) => a - b);
        const [firstPlay] = plays;
        const [lastPlay] = plays.slice(-1);
        let startSpot = 0;
        let endSpot = 0;
        let playsSum = 0;
        let yards = 0;

        if (isDefined(startYard)) {
            const { gameConfig } = gameContext;
            const { fieldLength } = gameConfig.general;

            startSpot = fieldLength - startYard;
            endSpot =
                fieldLength -
                (isDefined(endYard) ? endYard : gameContext.fieldPosition);
            yards = homeTeamHasPossession
                ? startSpot - endSpot
                : endSpot - startSpot;

            // StartDrive plays are no longer created, but legacy drives loaded
            // from storage/API may still carry one; keep excluding it so it
            // never inflates the play count.
            const excludedStates = [
                FootballState.StartDrive,
                FootballState.PatTry,
                FootballState.KickOff
            ];
            playsSum = plays.filter(
                (p) => !excludedStates.some((state) => p.historyContains(state))
            ).length;
        }

        return {
            awayTeam: !homeTeamHasPossession, //True or false depending on whether the possession during the drive corresponded to the away or home team.
            endHow: drive.completed ? endType?.code : undefined,
            endPlayIdx: lastPlay?.index,
            endQuarter: endPeriod,
            endSecs: endTime / 1000,
            endSpot,
            playsA: 0, // TODO - Number of Rush plays
            playsB: 0, // TODO - Number of Pass plays
            playsSum,
            redZone: gameContext.isInRedZone(),
            startHow: startType?.code,
            startPlayIdx: firstPlay?.index,
            startQuarter: startPeriod,
            startSecs: startTime / 1000,
            startSpot,
            topSecs: totalTime / 1000, // Time of possession of the drive
            yards: yards // Yards gain or loss
        };
    }
};
